const CONST = {
    UPDATE_IMAGE_STUDIO_STATE: 'UPDATE_IMAGE_STUDIO_STATE',
    SET_ORIGINAL_IMAGE: 'SET_ORIGINAL_IMAGE',
    SET_PROCESSED_IMAGE: 'SET_PROCESSED_IMAGE',
    UPDATE_IMAGE_STUDIO_FILES: 'UPDATE_IMAGE_STUDIO_FILES',
    SET_SELECTED_IMAGE_ID: 'SET_SELECTED_IMAGE_ID',
    SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
    SET_ACTIVE_ACTION: 'SET_ACTIVE_ACTION',
    SET_ACTIVE_OPERATION: 'SET_ACTIVE_OPERATION',
    SET_ACTIVE_SUB_ACTION: 'SET_ACTIVE_SUB_ACTION',
    UPDATE_SETTINGS: 'UPDATE_SETTINGS',
    SET_RESULTS: 'SET_RESULTS',
    RESET_IMAGE_STUDIO: 'RESET_IMAGE_STUDIO',
};

export default CONST;

